<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/43z0GR/tc-custom/9781567926750.jpg?1700957997605" alt="This image is the cover for the book Beneficence"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Beneficence
      </h1>
      <p class="bookDescription body article font2">
        <b>“People stay together, fall apart, come back together, altered. It is a book about work, about grief, about thick ongoing love” from the bestselling author (<i>The Boston Globe</i>).</b><br/><br/>In the midst of a nearly perfect life, Doris Senter is thankful but wary. “We can’t ever know what will come,” she says. When an unimaginable tragedy turns the family of five into a family of four, everything the Senters held faith in is shattered. The family is consumed by sorrow and guilt. Slowly, the surviving family members find their way to forgiveness—of themselves and of each other.<br/><br/>Few writers know the human heart and the burden of grief as well as <i>New York Times</i>-bestselling author Meredith Hall (<i>Without a Map</i>). This is a radiant novel of goodness and love—both its gifts and its obligations—that will stay with readers long after the last page. With a rare tenderness and compassion, <i>Beneficence</i> shows broken hearts becoming whole as this family reclaims their love and peace.<br/><br/><b>“If the word ‘luminous’ didn’t already exist, you’d have to invent it to describe Meredith Hall’s radiant new novel.” —Richard Russo, Pulitzer Prize-winning author </b><br/><br/><b>“A modern American masterpiece.” —Dani Shapiro, <i>New York Times</i>-bestselling author</b><br/><br/><b>“A quiet but steady book, one that echoes ancient and important rhythms.” —<i>The Washington Post</i></b><br/><br/><b>“One of the best books I’ve ever read.” —Simon Van Booy, award-winning author </b><br/><br/><b>“Spare but decked with moments of crystalline beauty . . . A family flounders in grief, but finds their way home through forgiveness and acceptance, in <i>Beneficence</i>, Meredith Hall’s gorgeous and moving new novel.” —<i>Foreword</i> (starred review)</b>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Meredith Hall
      </h2>
      
      <p class="authorDescription body article"><P><B>Meredith Hall</B>'s memoir <I>Without a Map</I> was instantly recognized as a classic of the genre and became a <I>New York Times</I> bestseller. It was named Best Book of the Year by <I>Kirkus</I> and <I>BookSense</I>, as well as <I>Elle’s</I> “Readers’ Pick of the Year.” Ms. Hall was a recipient of the 2004 Gift of Freedom Award from A Room of Her Own Foundation. Her work has appeared in the <I>Five Points</I>, <I>Gettysburg Review</I>, <I>Kenyon Review</I>, <I>Southern Review</I>, <I>New York Times</I>, and many other journals. Hall divides her time between Maine and California.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      David R. Godine
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?54cf7c64